import { React } from "react";
import styled from "styled-components";
import { Route, Routes, NavLink } from 'react-router-dom';
import MapContainer from "../../containers/MapContainer/MapContainer";
import About from "../About/About";

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(13, 12, 29, 0.35);
  opacity: ${({ open }) => (open ? 1 : 0)};
  pointer-events: ${({ open }) => (open ? "auto" : "none")};
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 9;
`;

const StyledMenu = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 300px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-right: 1px solid #e6e6e6;
  border-radius: 0 25px 25px 0;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-110%)")};
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

  @media (max-width: 576px) {
    width: 100%;
    border-radius: 0;
  }
`;

const MenuHeader = styled.div`
  padding: 76px 24px 16px;
  border-bottom: 1px solid #e6e6e6;

  h2 {
    margin: 0;
    font-family: "Hammersmith One", sans-serif;
    font-size: 22px;
    color: #0d0c1d;
  }

  p {
    margin: 4px 0 0;
    font-size: 12px;
    color: #8a8a8a;
  }
`;

const NavList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 12px;
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  border-radius: 10px;
  font-family: 'Helvetica Neue', Helvetica, Arial, Sans-Serif;
  font-size: 15px;
  font-weight: 600;
  color: #0d0c1d;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;

  svg {
    flex-shrink: 0;
    color: #8a8a8a;
    transition: color 0.2s ease;
  }

  &:hover {
    background: #f5f5f5;
  }

  &.active {
    color: #fc3a34;
    background: #fdf0f0;
    box-shadow: inset 3px 0 0 #fc3a34;

    svg {
      color: #fc3a34;
    }
  }
`;

const MenuFooter = styled.div`
  margin-top: auto;
  padding: 16px 24px;
  border-top: 1px solid #e6e6e6;
  font-size: 13px;
  color: #8a8a8a;

  a {
    color: #0d0c1d;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #fc3a34;
    }
  }
`;

const MapIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const InfoIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const NavMenu = (props) => {
  return (
    <>
      <Backdrop open={props.open} onClick={() => props.setOpenNav(false)} />
      <StyledMenu open={props.open}>
        <MenuHeader>
          <h2>Metrolink Map</h2>
          <p>Manchester tram network</p>
        </MenuHeader>
        <NavList>
          <StyledNavLink data-umami-event="Map button" end onClick={() => props.setOpenNav(false)} to="/">
            <MapIcon />
            Map
          </StyledNavLink>
          <StyledNavLink data-umami-event="About button" onClick={() => props.setOpenNav(false)} to="/about">
            <InfoIcon />
            About
          </StyledNavLink>
        </NavList>
        <MenuFooter>
          <a
            href="https://adamgibbons.dev"
            data-umami-event="External link clicked"
            data-umami-event-destination="adamgibbons.dev"
          >
            adamgibbons
          </a> · <a
            href="https://www.metrolink-map.com"
            data-umami-event="External link clicked"
            data-umami-event-destination="metrolink-map.com"
          >
            metrolink-map
          </a> · <a
            href="mailto:contact@metrolink-map.com"
            data-umami-event="External link clicked"
            data-umami-event-destination="contact@metrolink-map.com"
          >
            Contact
          </a>
        </MenuFooter>
      </StyledMenu>
      <Routes>
        <Route path="/" element={<MapContainer openNavbar={props.setOpenNav} />} />
        <Route path="/about" element={<About openNavbar={props.setOpenNav} />} />
      </Routes>
    </>
  );
};

export default NavMenu;
